import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { QuotationBuilder } from "../components/QuotationBuilder";
import CrmLayout from "@/components/feature/CrmLayout";
import { fetchApi } from "@/services/apiService";

export default function EditQuotationPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [quotation, setQuotation] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    fetchApi<any>(`/quotations/${id}`, undefined, null)
      .then((res) => {
        setQuotation(res);
      })
      .catch((err) => {
        console.error("Error loading quotation for edit:", err);
        setQuotation(null);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <CrmLayout title="Loading Quotation...">
        <div className="p-5 md:p-6 flex flex-col items-center justify-center min-h-[60vh]">
          <i className="ri-loader-4-line animate-spin text-3xl text-indigo-600 mb-3" />
          <p className="text-sm text-gray-500">Loading quotation for editing...</p>
        </div>
      </CrmLayout>
    );
  }

  if (!quotation) {
    return (
      <CrmLayout title="Quotation Not Found">
        <div className="p-5 md:p-6 flex flex-col items-center justify-center min-h-[60vh]">
          <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
            <i className="ri-file-unknow-line text-2xl text-gray-400" />
          </div>
          <h2 className="text-lg font-semibold text-gray-900 mb-1">Quotation not found</h2>
          <p className="text-sm text-gray-500 mb-4">This quotation may have been deleted or the link is invalid.</p>
          <button
            onClick={() => navigate("/quotations")}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line" /> Back to Quotations
          </button>
        </div>
      </CrmLayout>
    );
  }

  const lead = quotation.leadName || quotation.client_name
    ? {
        id: quotation.leadId || quotation.lead_id || 0,
        name: quotation.leadName || quotation.client_name,
        company: quotation.leadCompany || quotation.client_company || "",
        phone: quotation.leadPhone || quotation.client_phone || "",
        email: quotation.leadEmail || quotation.client_email || "",
      }
    : null;

  return (
    <QuotationBuilder
      mode="edit"
      quotationId={id}
      initialData={{
        quoteNo: quotation.quoteNo || quotation.quote_number,
        date: quotation.date || quotation.quote_date,
        validUntil: quotation.validUntil || quotation.valid_until,
        lead,
        agent: quotation.agent,
        terms: quotation.terms,
        items: quotation.items || [],
        discount: Number(quotation.discount) || 0,
      }}
    />
  );
}